export default {
  PERFECT_ADVICE: 'perfect-advice',
}
